import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <circle cx="5" cy="9" r="2" stroke="currentColor" />
        <path
            d="M7 13.5H3C2.72386 13.5 2.49772 13.2747 2.55045 13.0037C2.71884 12.1382 3.34725 11 5 11C6.65275 11 7.28116 12.1382 7.44955 13.0037C7.50229 13.2747 7.27614 13.5 7 13.5Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <circle cx="11" cy="4.5" r="2" stroke="currentColor" />
        <path
            d="M13 9H9C8.72386 9 8.49772 8.77472 8.55045 8.50366C8.71884 7.63816 9.34725 6.5 11 6.5C12.6528 6.5 13.2812 7.63816 13.4495 8.50366C13.5023 8.77472 13.2761 9 13 9Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default Icon;
